export default __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLGT9Z1xlFQ.b79065b4.woff2";